export const getLastPathField = (path : string) : string => {
    return path.split("/").pop() ?? ""
};

export const getNextPathField = (from: string, crt : string) => {
    return from?.replace?.(new RegExp(`${crt}`,"g"), "")?.split?.("/")
    return from?.replace?.(new RegExp(`${crt}`,"g"), "")?.split?.("/")?.shift?.() ?? ""
};
